<template>
  <div class="clase-view">
    <div class="clase-left">
      <PRO_Clase @selection-changed="handleSelectionChanged" />
    </div>
    <div class="clase-right">
      <PRO_Categorii :ClasaID="selectedRow" :ClasaNume="selectedNume" />
    </div>
  </div>
</template>

<script lang="ts">
import PRO_Categorii from './PRO_Categorii.vue';
import PRO_Clase from './PRO_Clase.vue';

export default {
  components: { PRO_Clase, PRO_Categorii },
  data() {
    return {
      selectedRow: null as any,
      selectedNume: '' as string,
    };
  },
  methods: {
    handleSelectionChanged(row: any) {
      this.selectedRow = row.ID;
      this.selectedNume = row.NumeArborescent || row.Nume || '';
    },
  },
};
</script>

<style scoped>
.clase-view {
  display: grid !important;
  grid-template-columns: 480px 1fr;
  grid-template-rows: 1fr;
  gap: 12px;
  width: 100%;
  height: calc(100vh - 110px);
  overflow: hidden;
  background: #f8fafc;
}
.clase-left {
  grid-column: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid #e2e8f0;
  background: #fff;
}
.clase-right {
  grid-column: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
}
</style>
